import { useRef, useCallback } from 'react';

/**
 * Manages screen reader announcements
 * @returns {Object} { announcerRef, announce }
 */
export function useAccessibility() {
  const announcerRef = useRef(null);

  const announce = useCallback((message) => {
    if (announcerRef.current) {
      announcerRef.current.textContent = message;
    }
  }, []);

  return { announcerRef, announce };
}
